module.exports = __webpack_public_path__ + "img/logo.9840c101.png";